import { useMemo } from 'react';
export const useHostAppName = () => useMemo(() => {
  if (window.hubspot && window.hubspot.bender && window.hubspot.bender.currentProject) {
    return window.hubspot.bender.currentProject;
  }
  return 'unknown';
}, []);